
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { Trash2, CheckCircle2, Library, Plus, MoveRight, X } from "lucide-react";
// import { toast } from "react-toastify";
// import SummaryApi from "../../common/SummaryApi";
// import api from "../../common/apiClient";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import { TbCancel } from "react-icons/tb";

// export default function BundleKraForm({ bundle, bundleId, onClose, onSave, onBackToWizard }) {
//   const [saving, setSaving] = useState(false);
//   const [showWeightModal, setShowWeightModal] = useState(false);
//   const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  
//   // Dependencies lists
//   const [departments, setDepartments] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [masterKras, setMasterKras] = useState([]);

//   const [form, setForm] = useState({
//     name: bundle?.name || "",
//     year: bundle?.year || new Date().getFullYear(),
//     description: bundle?.description || "",
//     reviewCycle: bundle?.reviewCycle || "3_MONTHS",
//     status: bundle?.status || "DRAFT",
//     departmentId: bundle?.departmentId?._id || bundle?.departmentId || "",
//     divisionId: bundle?.divisionId?._id || bundle?.divisionId || "",
//     designationId: bundle?.designationId?._id || bundle?.designationId || "",
//     kras: bundle?.kras?.map(k => ({
//       kraId: k.kraId?._id || k.kraId,
//       name: k.kraId?.name || k.name || "",
//       description: k.kraId?.description || k.description || "",
//       category: k.kraId?.category || k.category || "Technical", 
//       weightage: k.weightage || 0,
//       reviewCycle: k.reviewCycle || bundle?.reviewCycle || "3_MONTHS", 
//       monthlyTarget: k.monthlyTarget || k.kraId?.monthlyTarget || "",   
//       yearlyTarget: k.yearlyTarget || k.kraId?.yearlyTarget || "",     
//       isNew: !k.kraId
//     })) || [{ kraId: "", name: "", description: "", category: "Technical", weightage: 0, reviewCycle: "3_MONTHS", monthlyTarget: "", yearlyTarget: "", isNew: false }]
//   });

//   const loadDependencies = useCallback(async () => {
//     try {
//       const [deptRes, divRes, desRes, krasRes] = await Promise.all([
//         api.get(SummaryApi.getAllDepartments.url),
//         api.get(SummaryApi.getAllDivisions.url),
//         api.get(SummaryApi.getAllDesignations?.url || "/api/hr/designations"),
//         api.get(SummaryApi.getAllKraTemplates?.url || "/api/hr/kras/templates")
//       ]);

//       if (deptRes.data.success) setDepartments(deptRes.data.data.map(d => ({ label: d.name, value: d._id })));
//       if (divRes.data.success) setDivisions(divRes.data.data.map(d => ({ label: d.name, value: d._id })));
//       if (desRes.data.success) setDesignations(desRes.data.data.map(d => ({ label: d.title, value: d._id })));
//       if (krasRes.data.success) setMasterKras(krasRes.data.data);
//     } catch {
//       toast.error("Error loading dependency lists.");
//     }
//   }, []);

//   useEffect(() => { loadDependencies(); }, [loadDependencies]);

//   // ரீஃப்ரெஷ் (Refresh) செய்யும்போது View-One API மூலம் சின்க் செய்தல்
//   useEffect(() => {
//     const fetchSingleBundleOnReload = async () => {
//       if (!bundle && bundleId) {
//         try {
//           const endpoint = SummaryApi.getKraBundleById?.url
//             ? SummaryApi.getKraBundleById.url(bundleId)
//             : `/api/hr/kra/bundles/view-one/${bundleId}`;
          
//           const res = await api.get(endpoint);
//           if (res.data.success) {
//             const b = res.data.data;
//             setForm({
//               name: b.name || "",
//               year: b.year || new Date().getFullYear(),
//               description: b.description || "",
//               reviewCycle: b.reviewCycle || "3_MONTHS",
//               status: b.status || "DRAFT",
//               departmentId: b.departmentId?._id || b.departmentId || "",
//               divisionId: b.divisionId?._id || b.divisionId || "",
//               designationId: b.designationId?._id || b.designationId || "",
//               kras: b.kras?.map(k => ({
//                 kraId: k.kraId?._id || k.kraId,
//                 name: k.kraId?.name || k.name || "",
//                 description: k.kraId?.description || k.description || "",
//                 category: k.kraId?.category || k.category || "Technical",
//                 weightage: k.weightage || 0,
//                 reviewCycle: k.reviewCycle || b.reviewCycle || "3_MONTHS", 
//                 monthlyTarget: k.monthlyTarget || k.kraId?.monthlyTarget || "",   
//                 yearlyTarget: k.yearlyTarget || k.kraId?.yearlyTarget || "",     
//                 isNew: !k.kraId
//               })) || [{ kraId: "", name: "", description: "", category: "Technical", weightage: 0, reviewCycle: "3_MONTHS", monthlyTarget: "", yearlyTarget: "", isNew: false }]
//             });
//           }
//         } catch {
//           toast.error("Failed to recover bundle details on reload.");
//         }
//       }
//     };
//     fetchSingleBundleOnReload();
//   }, [bundle, bundleId]);

//   // Props சின்க் அமைப்பு
//   useEffect(() => {
//     if (bundle) {
//       setForm({
//         name: bundle.name || "",
//         year: bundle.year || new Date().getFullYear(),
//         description: bundle.description || "",
//         reviewCycle: bundle.reviewCycle || "3_MONTHS",
//         status: bundle.status || "DRAFT",
//         departmentId: bundle.departmentId?._id || bundle.departmentId || "",
//         divisionId: bundle.divisionId?._id || bundle.divisionId || "",
//         designationId: bundle.designationId?._id || bundle.designationId || "",
//         kras: bundle.kras?.map(k => ({
//           kraId: k.kraId?._id || k.kraId,
//           name: k.kraId?.name || k.name || "",
//           description: k.kraId?.description || k.description || "",
//           category: k.kraId?.category || k.category || "Technical",
//           weightage: k.weightage || 0,
//           reviewCycle: k.reviewCycle || bundle.reviewCycle || "3_MONTHS", 
//           monthlyTarget: k.monthlyTarget || k.kraId?.monthlyTarget || "",   
//           yearlyTarget: k.yearlyTarget || k.kraId?.yearlyTarget || "",     
//           isNew: !k.kraId
//         })) || [{ kraId: "", name: "", description: "", category: "Technical", weightage: 0, reviewCycle: "3_MONTHS", monthlyTarget: "", yearlyTarget: "", isNew: false }]
//       });
//     }
//   }, [bundle]);

//   const activeKrasOptions = useMemo(() => {
//     return masterKras.map(k => ({ label: k.name, value: k._id }));
//   }, [masterKras]);

//   // Duplicate KRA Selection-ஐத் தடுப்பதற்கான dynamic dropdown options கணக்கீடு:
//   const getKrasOptionsForIndex = (currentIndex) => {
//     const selectedIdsInOtherRows = form.kras
//       .map((k, idx) => idx !== currentIndex ? k.kraId : null)
//       .filter(Boolean);
//     return activeKrasOptions.filter(opt => !selectedIdsInOtherRows.includes(opt.value));
//   };

//   const handleAddListItem = () => {
//     setForm(p => ({
//       ...p,
//       kras: [...p.kras, { kraId: "", name: "", description: "", category: "Technical", weightage: 0, reviewCycle: "3_MONTHS", monthlyTarget: "", yearlyTarget: "", isNew: false }]
//     }));
//   };

//   const handleRemoveListItem = (index) => {
//     if (form.kras.length <= 1) return toast.error("At least one KRA must be in the bundle.");
//     setForm(p => ({
//       ...p,
//       kras: p.kras.filter((_, idx) => idx !== index)
//     }));
//   };

//   const handleItemChange = (index, key, value) => {
//     const updatedKras = form.kras.map((item, idx) => {
//       if (idx !== index) return item;
      
//       const updated = { ...item, [key]: value };
      
//       if (key === "kraId" && value) {
//         const template = masterKras.find(k => k._id === value);
//         if (template) {
//           updated.name = template.name;
//           updated.description = template.description;
//           updated.category = template.category || "Technical"; 
//           updated.reviewCycle = template.reviewCycle || "3_MONTHS";
//           updated.monthlyTarget = template.monthlyTarget || "";
//           updated.yearlyTarget = template.yearlyTarget || "";
//           updated.isNew = false;
//         }
//       }
//       return updated;
//     });

//     setForm(p => ({ ...p, kras: updatedKras }));
//   };

//   const handleAutoSplitWeights = () => {
//     const totalKras = form.kras.length;
//     if (totalKras === 0) return;

//     const baseWeight = Math.floor(100 / totalKras);
//     const remainder = 100 % totalKras;

//     const updated = form.kras.map((k, idx) => {
//       const weight = idx < remainder ? baseWeight + 1 : baseWeight;
//       return { ...k, weightage: weight };
//     });

//     setForm(p => ({ ...p, kras: updated }));
//     toast.info("Weights distributed equally!");
//   };

//   const handleOpenWeightsModal = () => {
//     if (!form.name.trim()) return toast.error("Bundle Name is required.");
    
//     for (let i = 0; i < form.kras.length; i++) {
//       const item = form.kras[i];
//       if (!item.kraId) {
//         if (!item.name.trim()) return toast.error(`KRA Item #${i + 1} has incomplete name.`);
//         if (!item.description.trim()) return toast.error(`KRA Item #${i + 1} has incomplete description.`);
//         if (!item.category || !item.category.trim()) return toast.error(`KRA Item #${i + 1} has incomplete category.`);
//       }
//       if (!item.reviewCycle) {
//         return toast.error(`KRA Item #${i + 1} has incomplete review cycle.`);
//       }
//     }

//     setShowWeightModal(true);
//   };

//   const handleWeightChangeInModal = (index, val) => {
//     const updated = form.kras.map((k, idx) => 
//       idx === index ? { ...k, weightage: Number(val) || 0 } : k
//     );
//     setForm(p => ({ ...p, kras: updated }));
//   };

//   const totalCalculatedWeight = useMemo(() => {
//     return form.kras.reduce((sum, k) => sum + Number(k.weightage), 0);
//   }, [form.kras]);

//   const handleCreateBundleFinal = async () => {
//     // 100-க்கு மிகாமல் இருக்க வேண்டும் என மாற்றப்பட்டது (<= 100)
//     if (totalCalculatedWeight > 100) {
//       return toast.error("The combined KRA weightage inside a bundle cannot exceed 100%.");
//     }

//     setSaving(true);
//     try {
//       const endpoint = bundle?._id
//         ? SummaryApi.updateKraBundle?.url(bundle._id)
//         : SummaryApi.createKraBundle?.url;

//       const method = bundle?._id ? "put" : "post";
//       await api[method](endpoint, form);

//       setShowWeightModal(false);
//       setShowSuccessScreen(true); 
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to create KRA Bundle.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="space-y-4 p-2">
//       {/* SUCCESS OVERLAY SCREEN */}
//       {showSuccessScreen && (
//         <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
//           <div className="bg-white rounded-xl max-w-md w-full p-8 text-center space-y-6 shadow-2xl animate-scale-in">
//             <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto text-green-700">
//               <CheckCircle2 className="w-10 h-10" />
//             </div>

//             <div>
//               <h3 className="text-xl font-bold text-gray-900 leading-tight">
//                 {bundle ? "Bundle Updated Successfully" : "Bundle Created Successfully"}
//               </h3>
//               <p className="text-xs text-gray-400 mt-2 leading-relaxed">
//                 {bundle 
//                   ? "The performance KRA bundle has been successfully updated and saved in the organizational repository."
//                   : "The new performance KRA bundle is now saved and available in the organizational repository."
//                 }
//               </p>
//             </div>

//             {/* Inner progress details card */}
//             <div className="bg-gray-50 border border-gray-100 rounded-lg p-5 text-left space-y-4">
//               <div>
//                 <p className="text-[10px] font-bold text-gray-400 uppercase">Bundle Name</p>
//                 <p className="text-sm font-extrabold text-gray-800">{form.name}</p>
//               </div>
//               <div className="flex justify-between items-center text-xs">
//                 <div>
//                   <p className="text-[10px] font-bold text-gray-400 uppercase">Contains</p>
//                   <p className="font-extrabold text-gray-800">{form.kras.length} KRAs</p>
//                 </div>
//                 <div className="text-right">
//                   <p className="text-[10px] font-bold text-gray-400 uppercase">Total Weight</p>
//                   <p className="font-extrabold text-primary">{totalCalculatedWeight}%</p>
//                 </div>
//               </div>
//               <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
//                 <div className="bg-green-700 h-full rounded-full" style={{ width: `${Math.min(100, totalCalculatedWeight)}%` }} />
//               </div>
//             </div>

//             <div className="flex flex-col gap-3 pt-2">
//               <button onClick={() => { setShowSuccessScreen(false); onSave(); }} className="w-full bg-primary hover:bg-secondary text-white py-3 rounded-lg font-bold text-xs uppercase hover:shadow-lg transition-all">
//                 Go to KRA Library
//               </button>
//               <button onClick={() => { setShowSuccessScreen(false); onClose(); }} className="text-xs text-gray-400 hover:text-red-500 font-bold uppercase transition-colors">
//                 Back to Dashboard
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* WEIGHT ASSIGNMENT MODAL */}
//       {showWeightModal && (
//         <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
//           <div className="bg-white rounded-xl max-w-lg w-full shadow-xl flex flex-col max-h-[85vh] overflow-hidden animate-scale-in">
//             <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
//               <h3 className="font-bold text-gray-900 text-lg md:text-xl">Bundle Weight Assignment</h3>
//               <button onClick={() => setShowWeightModal(false)} className="text-gray-400 font-bold hover:text-primary transition-transform duration-300 hover:rotate-180"><X/></button>
//             </div>

//             <div className="flex-1 overflow-y-auto p-4 space-y-6">
//               <div className="bg-gray-50 border p-4 rounded-lg">
//                 <span className="text-[10px] bg-red-100 text-primary font-bold px-2 py-0.5 rounded uppercase">Bundle Identity</span>
//                 <h4 className="font-bold text-gray-800 text-sm mt-2">{form.name}</h4>
//                 <p className="text-xs text-gray-400 mt-1 leading-relaxed">{form.description || "No description provided."}</p>
//               </div>

//               {/* Individual Weight adjustments */}
//               <div className="space-y-4">
//                 <div className="flex justify-between items-center border-b pb-2 text-[10px] font-bold text-gray-400 uppercase">
//                   <span>KRA Name</span>
//                   <button
//                     type="button"
//                     onClick={handleAutoSplitWeights}
//                     className="text-[10px] text-primary hover:text-secondary font-bold uppercase underline transition-colors focus:outline-none"
//                   >
//                     Distribute Equally
//                   </button>
//                 </div>
                
//                 {form.kras.map((k, idx) => (
//                   <div key={idx} className="flex justify-between items-center gap-4">
//                     <div className="min-w-0 flex-1">
//                       <p className="text-xs font-bold text-gray-800 truncate">{k.name || "Custom KRA"}</p>
//                       <p className="text-[10px] text-gray-400 truncate mt-0.5">{k.description}</p>
//                     </div>
//                     <div className="flex items-center gap-1.5 shrink-0">
//                       <input 
//                         type="number" 
//                         value={k.weightage || ""}
//                         onChange={(e) => handleWeightChangeInModal(idx, e.target.value)}
//                         className="w-16 border rounded-lg px-2.5 py-1.5 text-center text-xs font-bold outline-none focus:ring-1 focus:ring-red-400"
//                         min={0}
//                         max={100}
//                       />
//                       <span className="text-xs text-gray-400 font-bold">%</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Bottom Progress Bar inside Modal */}
//             <div className="p-6 border-t bg-gray-50 space-y-4">
//               <div className="flex justify-between items-center text-xs font-bold">
//                 <span className="text-gray-700">Current Total: {totalCalculatedWeight}%</span>
//                 <span className="text-primary tracking-wide text-[10px] uppercase">Total weight must not exceed 100%</span>
//               </div>
//               <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
//                 <div className={`h-full rounded-full transition-all duration-300 ${totalCalculatedWeight <= 100 ? "bg-green-500" : "bg-primary"}`} style={{ width: `${Math.min(100, totalCalculatedWeight)}%` }} />
//               </div>

//               <div className="flex gap-3 pt-2">
//                 <button onClick={() => setShowWeightModal(false)} className="flex-1 bg-white border py-2.5 rounded-lg text-xs font-bold text-gray-600 hover:bg-gray-100 uppercase">
//                   Cancel
//                 </button>
//                 <button onClick={handleCreateBundleFinal} disabled={saving} className="flex-1 bg-primary text-white py-2.5 rounded-lg text-xs font-bold uppercase hover:shadow-lg hover:bg-secondary transition-all">
//                   {saving ? "Saving..." : (bundle ? "Update Bundle" : "Create Bundle")}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Interactive Breadcrumbs Header */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
//         <nav className="text-xs md:text-sm text-primary font-medium flex items-center gap-1.5 flex-wrap" aria-label="Breadcrumb">
//           <button 
//             type="button"
//             onClick={onClose} 
//             className="hover:text-secondary transition-colors focus:outline-none"
//           >
//             KRA Library
//           </button>
//           <span className="text-gray-300">&gt;</span>
          
//           <button 
//             type="button"
//             onClick={onBackToWizard || onClose} 
//             className="hover:text-secondary transition-colors focus:outline-none"
//           >
//             Bundle KRA
//           </button>
//           <span className="text-gray-300">&gt;</span>
          
//           <span className="text-secondary font-bold">
//             {bundle ? "Edit Bundle" : "Create KRA Bundle"}
//           </span>
//         </nav>

//         <div className="text-lg md:text-2xl font-bold text-gray-900 tracking-tight">
//           Bundle KRA
//         </div>
//       </div>

//       {/* BUNDLE DETAILS CARD PANEL */}
//       <div className="bg-white rounded-xl p-6 space-y-6">
//         <div className="border-b border-gray-100 pb-3 flex items-center gap-2">
//           <span className="p-1.5 bg-red-100 rounded-md text-primary"><Library size={20} /></span>
//           <h3 className="font-bold text-gray-800 text-sm uppercase tracking-wider">Bundle Information</h3>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Bundle Name <span className="text-primary">*</span></label>
//             <input 
//               type="text" 
//               value={form.name}
//               onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))}
//               placeholder="e.g. Executive Leadership Q3"
//               className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Financial Year</label>
//             <input 
//               type="number" 
//               value={form.year}
//               onChange={(e) => setForm(p => ({ ...p, year: Number(e.target.value) || new Date().getFullYear() }))}
//               className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
//             />
//           </div>
          
//           {/* Active / Draft Toggle switch */}
//           <div className="flex flex-col justify-end">
//             <span className="block text-xs font-bold text-gray-700 uppercase mb-1">Status</span>
//             <div className="flex items-center gap-3 bg-gray-50/50 p-2 border border-gray-200 rounded-lg max-w-[160px] h-[42px]">
//               <button 
//                 type="button"
//                 onClick={() => setForm(p => ({ ...p, status: p.status === "ACTIVE" ? "DRAFT" : "ACTIVE" }))}
//                 className={`relative inline-flex h-6 w-11 rounded-full transition-colors ${form.status === "ACTIVE" ? "bg-primary" : "bg-gray-300"}`}
//               >
//                 <span className={`inline-block h-4 w-4 mt-1 ml-1 rounded-full bg-white transition-transform ${form.status === "ACTIVE" ? "translate-x-5" : "translate-x-0"}`} />
//               </button>
//               <span className="text-xs font-bold text-gray-600 uppercase">
//                 {form.status === "ACTIVE" ? "Active" : "Draft"}
//               </span>
//             </div>
//           </div>
//         </div>

//         <div>
//           <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Bundle Description</label>
//           <textarea 
//             value={form.description}
//             onChange={(e) => setForm(p => ({ ...p, description: e.target.value }))}
//             placeholder="Key performance indicators for the team focused on strategic growth..."
//             rows={3}
//             className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-red-200 resize-none"
//           />
//         </div>

//         {/* Structural options are updated with searchable={true} */}
//         <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Review Cycle</label>
//             <SelectDropdown options={[{ label: 'Monthly', value: '1_MONTH' }, { label: 'Quarterly', value: '3_MONTHS' }, { label: 'Half-Yearly', value: '6_MONTHS' }, { label: 'Annual', value: '12_MONTHS' }]} value={form.reviewCycle} onChange={(v) => setForm(p => ({ ...p, reviewCycle: v }))} placeholder="Select cycle" valueKey="value" labelKey="label" searchable={true} />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Division</label>
//             <SelectDropdown options={divisions} value={form.divisionId} onChange={(v) => setForm(p => ({ ...p, divisionId: v }))} placeholder="Select division" valueKey="value" labelKey="label" searchable={true} />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Department</label>
//             <SelectDropdown options={departments} value={form.departmentId} onChange={(v) => setForm(p => ({ ...p, departmentId: v }))} placeholder="Select department" valueKey="value" labelKey="label" searchable={true} />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Designation</label>
//             <SelectDropdown options={designations} value={form.designationId} onChange={(v) => setForm(p => ({ ...p, designationId: v }))} placeholder="Select designation" valueKey="value" labelKey="label" searchable={true} />
//           </div>
//         </div>
//       </div>

//       {/* KRA LIST BUILDER CONTAINER */}
//       <div className="space-y-4">
//         <div className="flex justify-between items-center border-b pb-1">
//           <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider">KRA List</h4>
//           <button onClick={handleAddListItem} className="text-xs bg-primary text-white hover:bg-secondary px-3 py-2 font-bold rounded-lg flex items-center gap-1">
//            <Plus strokeWidth={4} size={16}/> Add Another KRA
//           </button>
//         </div>

//         <div className="space-y-4">
//           {form.kras.map((k, idx) => (
//             <div key={idx} className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm relative space-y-4">
//               <div className="flex justify-between items-center">
//                 <span className="flex h-8 w-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 font-bold text-[10px]">
//                   {String(idx + 1).padStart(2, "0")}
//                 </span>
//                 <button onClick={() => handleRemoveListItem(idx)} className="text-gray-400 hover:text-red-500 p-1.5 rounded-lg">
//                   <Trash2 className="w-4 h-4" />
//                 </button>
//               </div>

//               <div className="flex items-center gap-4 bg-gray-50 p-2.5 rounded-lg border border-gray-100 max-w-[320px]">
//                 <button 
//                   type="button"
//                   onClick={() => handleItemChange(idx, "isNew", false)}
//                   className={`flex-1 py-1.5 rounded-lg text-[10px] font-bold uppercase transition-all ${
//                     !k.isNew ? "bg-primary text-white shadow-sm" : "text-gray-500 hover:text-white hover:bg-secondary"
//                   }`}
//                 >
//                   Select Existing
//                 </button>
//                 <button 
//                   type="button"
//                   onClick={() => handleItemChange(idx, "isNew", true)}
//                   className={`flex-1 py-1.5 rounded-lg text-[10px] font-bold uppercase transition-all ${
//                     k.isNew ? "bg-primary text-white shadow-sm" : "text-gray-500 hover:text-white hover:bg-secondary"
//                   }`}
//                 >
//                   Create Custom New
//                 </button>
//               </div>

//               {!k.isNew ? (
//                 <div>
//                   <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Select KRA Master <span className="text-primary">*</span></label>
//                   <SelectDropdown 
//                     options={getKrasOptionsForIndex(idx)} // Dynamic custom options computed to filter out duplicates
//                     value={k.kraId}
//                     onChange={(v) => handleItemChange(idx, "kraId", v)}
//                     placeholder="Search and select existing template..."
//                     searchable={true}
//                     valueKey="value"
//                     labelKey="label"
//                   />
//                 </div>
//               ) : (
//                 <div className="space-y-3">
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-xs font-bold text-gray-700 uppercase mb-1">KRA Name <span className="text-primary">*</span></label>
//                       <input 
//                         type="text" 
//                         value={k.name}
//                         onChange={(e) => handleItemChange(idx, "name", e.target.value)}
//                         placeholder="e.g. Sales Target Achievement"
//                         className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200"
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Category <span className="text-primary">*</span></label>
//                       <input 
//                         type="text" 
//                         value={k.category}
//                         onChange={(e) => handleItemChange(idx, "category", e.target.value)}
//                         placeholder="e.g. Technical, Behavioral"
//                         className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200"
//                       />
//                     </div>
//                   </div>
//                   <div>
//                     <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Description <span className="text-primary">*</span></label>
//                     <textarea 
//                       value={k.description}
//                       onChange={(e) => handleItemChange(idx, "description", e.target.value)}
//                       placeholder="Describe primary objective and outcome..."
//                       rows={2}
//                       className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200 resize-none"
//                     />
//                   </div>
//                 </div>
//               )}

//               {/* Individual Cycle and Targets for KRA Bundle Item */}
//               <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 border-t border-gray-100 pt-4">
//                 <div>
//                   <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Review Cycle <span className="text-primary">*</span></label>
//                   <SelectDropdown 
//                     options={[
//                       { label: 'Monthly', value: '1_MONTH' }, 
//                       { label: 'Quarterly', value: '3_MONTHS' }, 
//                       { label: 'Half-Yearly', value: '6_MONTHS' }, 
//                       { label: 'Annual', value: '12_MONTHS' }
//                     ]} 
//                     value={k.reviewCycle} 
//                     onChange={(v) => handleItemChange(idx, "reviewCycle", v)} 
//                     placeholder="Select cycle" 
//                     valueKey="value" 
//                     labelKey="label" 
//                     searchable={true}
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Monthly Target (Optional)</label>
//                   <input 
//                     type="text" 
//                     value={k.monthlyTarget}
//                     onChange={(e) => handleItemChange(idx, "monthlyTarget", e.target.value)}
//                     placeholder="e.g. ₹5 Lakhs Sales"
//                     className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Yearly Target (Optional)</label>
//                   <input 
//                     type="text" 
//                     value={k.yearlyTarget}
//                     onChange={(e) => handleItemChange(idx, "yearlyTarget", e.target.value)}
//                     placeholder="e.g. ₹60 Lakhs"
//                     className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200"
//                   />
//                 </div>
//               </div>

//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Footer action bar */}
//       <div className="flex flex-col sm:flex-row justify-between items-center gap-4 ">
//         <button
//           onClick={onClose}
//           className="w-full sm:w-auto flex items-center justify-center gap-2 px-5 py-2.5 border border-gray-300 text-gray-600 hover:bg-gray-200 font-bold rounded-lg text-xs uppercase transition-colors"
//         >
//           <TbCancel className="text-base" />
//           <span>Discard</span>
//         </button>
        
//         {/* Dynamic Main Form Footer Button */}
//         <button onClick={handleOpenWeightsModal} className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3 bg-primary hover:bg-secondary text-white font-bold rounded-lg text-xs uppercase hover:shadow-lg transition-all">
//           {bundle ? "Assign Weights & Update Bundle" : "Assign Weights & Save Bundle"} <MoveRight strokeWidth={2} size={20}/>
//         </button>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Trash2, CheckCircle2, Library, Plus, MoveRight, X } from "lucide-react";
import { toast } from "react-toastify";
import SummaryApi from "../../common/SummaryApi";
import api from "../../common/apiClient";
import SelectDropdown from "../../customStyles/SelectDropdown";
import { TbCancel } from "react-icons/tb";

// Standard cycles representing the system configurations
const CYCLE_OPTIONS = [
  { label: "Weekly", value: "1_WEEK" },
  { label: "Bi-weekly", value: "2_WEEKS" },
  { label: "Monthly", value: "1_MONTH" }, 
  { label: "Quarterly", value: "3_MONTHS" }, 
  { label: "Half-Yearly", value: "6_MONTHS" }, 
  { label: "Annual", value: "12_MONTHS" }
];

// ✅ Added metricType options constant
const METRIC_TYPE_OPTIONS = [
  { label: "Higher is Better (Direct Goal)", value: "HIGHER_IS_BETTER" },
  { label: "Lower is Better (Inverse Goal)", value: "LOWER_IS_BETTER" }
];

export default function BundleKraForm({ bundle, bundleId, onClose, onSave, onBackToWizard }) {
  const [saving, setSaving] = useState(false);
  const [showWeightModal, setShowWeightModal] = useState(false);
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  
  const [departments, setDepartments] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [masterKras, setMasterKras] = useState([]);

  const [form, setForm] = useState({
    name: bundle?.name || "",
    year: bundle?.year || new Date().getFullYear(),
    description: bundle?.description || "",
    reviewCycle: bundle?.reviewCycle || "3_MONTHS",
    status: bundle?.status || "DRAFT",
    departmentId: bundle?.departmentId?._id || bundle?.departmentId || "",
    divisionId: bundle?.divisionId?._id || bundle?.divisionId || "",
    designationId: bundle?.designationId?._id || bundle?.designationId || "",
    kras: bundle?.kras?.map(k => ({
      kraId: k.kraId?._id || k.kraId,
      name: k.kraId?.name || k.name || "",
      description: k.kraId?.description || k.description || "",
      category: k.kraId?.category || k.category || "Technical", 
      weightage: k.weightage || 0,
      reviewCycle: k.reviewCycle || bundle?.reviewCycle || "3_MONTHS", 
      targetValue: k.targetValue || k.kraId?.targetValue || "",
      metricType: k.metricType || k.kraId?.metricType || "HIGHER_IS_BETTER", // ✅ Synchronized metricType
      monthlyTarget: k.monthlyTarget || k.kraId?.monthlyTarget || "",   
      yearlyTarget: k.yearlyTarget || k.kraId?.yearlyTarget || "",     
      isNew: !k.kraId
    })) || [{ kraId: "", name: "", description: "", category: "Technical", weightage: 0, reviewCycle: "3_MONTHS", targetValue: "", metricType: "HIGHER_IS_BETTER", monthlyTarget: "", yearlyTarget: "", isNew: false }]
  });

  const loadDependencies = useCallback(async () => {
    try {
      const [deptRes, divRes, desRes, krasRes] = await Promise.all([
        api.get(SummaryApi.getAllDepartments.url),
        api.get(SummaryApi.getAllDivisions.url),
        api.get(SummaryApi.getAllDesignations?.url || "/api/hr/designations"),
        api.get(SummaryApi.getAllKraTemplates?.url || "/api/hr/kras/templates")
      ]);

      if (deptRes.data.success) setDepartments(deptRes.data.data.map(d => ({ label: d.name, value: d._id })));
      if (divRes.data.success) setDivisions(divRes.data.data.map(d => ({ label: d.name, value: d._id })));
      if (desRes.data.success) setDesignations(desRes.data.data.map(d => ({ label: d.title, value: d._id })));
      if (krasRes.data.success) setMasterKras(krasRes.data.data);
    } catch {
      toast.error("Error loading dependency lists.");
    }
  }, []);

  useEffect(() => { loadDependencies(); }, [loadDependencies]);

  // View-One sync on refresh
  useEffect(() => {
    const fetchSingleBundleOnReload = async () => {
      if (!bundle && bundleId) {
        try {
          const endpoint = SummaryApi.getKraBundleById?.url
            ? SummaryApi.getKraBundleById.url(bundleId)
            : `/api/hr/kra/bundles/view-one/${bundleId}`;
          
          const res = await api.get(endpoint);
          if (res.data.success) {
            const b = res.data.data;
            setForm({
              name: b.name || "",
              year: b.year || new Date().getFullYear(),
              description: b.description || "",
              reviewCycle: b.reviewCycle || "3_MONTHS",
              status: b.status || "DRAFT",
              departmentId: b.departmentId?._id || b.departmentId || "",
              divisionId: b.divisionId?._id || b.divisionId || "",
              designationId: b.designationId?._id || b.designationId || "",
              kras: b.kras?.map(k => ({
                kraId: k.kraId?._id || k.kraId,
                name: k.kraId?.name || k.name || "",
                description: k.kraId?.description || k.description || "",
                category: k.kraId?.category || k.category || "Technical",
                weightage: k.weightage || 0,
                reviewCycle: k.reviewCycle || b.reviewCycle || "3_MONTHS", 
                targetValue: k.targetValue || k.kraId?.targetValue || "",
                metricType: k.metricType || k.kraId?.metricType || "HIGHER_IS_BETTER", // ✅ Synchronized metricType
                monthlyTarget: k.monthlyTarget || k.kraId?.monthlyTarget || "",   
                yearlyTarget: k.yearlyTarget || k.kraId?.yearlyTarget || "",     
                isNew: !k.kraId
              })) || [{ kraId: "", name: "", description: "", category: "Technical", weightage: 0, reviewCycle: "3_MONTHS", targetValue: "", metricType: "HIGHER_IS_BETTER", monthlyTarget: "", yearlyTarget: "", isNew: false }]
            });
          }
        } catch {
          toast.error("Failed to recover bundle details on reload.");
        }
      }
    };
    fetchSingleBundleOnReload();
  }, [bundle, bundleId]);

  // Props synchronization
  useEffect(() => {
    if (bundle) {
      setForm({
        name: bundle.name || "",
        year: bundle.year || new Date().getFullYear(),
        description: bundle.description || "",
        reviewCycle: bundle.reviewCycle || "3_MONTHS",
        status: bundle.status || "DRAFT",
        departmentId: bundle.departmentId?._id || bundle.departmentId || "",
        divisionId: bundle.divisionId?._id || bundle.divisionId || "",
        designationId: bundle.designationId?._id || bundle.designationId || "",
        kras: bundle.kras?.map(k => ({
          kraId: k.kraId?._id || k.kraId,
          name: k.kraId?.name || k.name || "",
          description: k.kraId?.description || k.description || "",
          category: k.kraId?.category || k.category || "Technical",
          weightage: k.weightage || 0,
          reviewCycle: k.reviewCycle || bundle.reviewCycle || "3_MONTHS", 
          targetValue: k.targetValue || k.kraId?.targetValue || "",
          metricType: k.metricType || k.kraId?.metricType || "HIGHER_IS_BETTER", // ✅ Synchronized metricType
          monthlyTarget: k.monthlyTarget || k.kraId?.monthlyTarget || "",   
          yearlyTarget: k.yearlyTarget || k.kraId?.yearlyTarget || "",     
          isNew: !k.kraId
        })) || [{ kraId: "", name: "", description: "", category: "Technical", weightage: 0, reviewCycle: "3_MONTHS", targetValue: "", metricType: "HIGHER_IS_BETTER", monthlyTarget: "", yearlyTarget: "", isNew: false }]
      });
    }
  }, [bundle]);

  const activeKrasOptions = useMemo(() => {
    return masterKras.map(k => ({ label: k.name, value: k._id }));
  }, [masterKras]);

  const getKrasOptionsForIndex = (currentIndex) => {
    const selectedIdsInOtherRows = form.kras
      .map((k, idx) => idx !== currentIndex ? k.kraId : null)
      .filter(Boolean);
    return activeKrasOptions.filter(opt => !selectedIdsInOtherRows.includes(opt.value));
  };

  const handleAddListItem = () => {
    setForm(p => ({
      ...p,
      kras: [...p.kras, { kraId: "", name: "", description: "", category: "Technical", weightage: 0, reviewCycle: "3_MONTHS", targetValue: "", metricType: "HIGHER_IS_BETTER", monthlyTarget: "", yearlyTarget: "", isNew: false }] // ✅ Added metricType default
    }));
  };

  const handleRemoveListItem = (index) => {
    if (form.kras.length <= 1) return toast.error("At least one KRA must be in the bundle.");
    setForm(p => ({
      ...p,
      kras: p.kras.filter((_, idx) => idx !== index)
    }));
  };

  const handleItemChange = (index, key, value) => {
    const updatedKras = form.kras.map((item, idx) => {
      if (idx !== index) return item;
      
      const updated = { ...item, [key]: value };
      
      if (key === "kraId" && value) {
        const template = masterKras.find(k => k._id === value);
        if (template) {
          updated.name = template.name;
          updated.description = template.description;
          updated.category = template.category || "Technical"; 
          updated.reviewCycle = template.reviewCycle || "3_MONTHS";
          updated.targetValue = template.targetValue || ""; 
          updated.metricType = template.metricType || "HIGHER_IS_BETTER"; // ✅ Automap metricType from template
          updated.monthlyTarget = template.monthlyTarget || "";
          updated.yearlyTarget = template.yearlyTarget || "";
          updated.isNew = false;
        }
      }
      return updated;
    });

    setForm(p => ({ ...p, kras: updatedKras }));
  };

  const handleAutoSplitWeights = () => {
    const totalKras = form.kras.length;
    if (totalKras === 0) return;

    const baseWeight = Math.floor(100 / totalKras);
    const remainder = 100 % totalKras;

    const updated = form.kras.map((k, idx) => {
      const weight = idx < remainder ? baseWeight + 1 : baseWeight;
      return { ...k, weightage: weight };
    });

    setForm(p => ({ ...p, kras: updated }));
    toast.info("Weights distributed equally!");
  };

  const handleOpenWeightsModal = () => {
    if (!form.name.trim()) return toast.error("Bundle Name is required.");
    
    for (let i = 0; i < form.kras.length; i++) {
      const item = form.kras[i];
      if (!item.kraId) {
        if (!item.name.trim()) return toast.error(`KRA Item #${i + 1} has incomplete name.`);
        if (!item.description.trim()) return toast.error(`KRA Item #${i + 1} has incomplete description.`);
        if (!item.category || !item.category.trim()) return toast.error(`KRA Item #${i + 1} has incomplete category.`);
      }
      if (!item.reviewCycle) {
        return toast.error(`KRA Item #${i + 1} has incomplete review cycle.`);
      }
    }

    setShowWeightModal(true);
  };

  const handleWeightChangeInModal = (index, val) => {
    const updated = form.kras.map((k, idx) => 
      idx === index ? { ...k, weightage: Number(val) || 0 } : k
    );
    setForm(p => ({ ...p, kras: updated }));
  };

  const totalCalculatedWeight = useMemo(() => {
    return form.kras.reduce((sum, k) => sum + Number(k.weightage), 0);
  }, [form.kras]);

  const handleCreateBundleFinal = async () => {
    if (totalCalculatedWeight > 100) {
      return toast.error("The combined KRA weightage inside a bundle cannot exceed 100%.");
    }

    setSaving(true);
    try {
      const endpoint = bundle?._id
        ? SummaryApi.updateKraBundle?.url(bundle._id)
        : SummaryApi.createKraBundle?.url;

      const method = bundle?._id ? "put" : "post";
      await api[method](endpoint, form);

      setShowWeightModal(false);
      setShowSuccessScreen(true); 
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create KRA Bundle.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4 p-2">
      {/* SUCCESS OVERLAY SCREEN */}
      {showSuccessScreen && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl max-w-md w-full p-8 text-center space-y-6 shadow-2xl animate-scale-in">
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto text-green-700">
              <CheckCircle2 className="w-10 h-10" />
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 leading-tight">
                {bundle ? "Bundle Updated Successfully" : "Bundle Created Successfully"}
              </h3>
              <p className="text-xs text-gray-400 mt-2 leading-relaxed">
                {bundle 
                  ? "The performance KRA bundle has been successfully updated and saved in the organizational repository."
                  : "The new performance KRA bundle is now saved and available in the organizational repository."
                }
              </p>
            </div>

            <div className="bg-gray-50 border border-gray-100 rounded-lg p-5 text-left space-y-4">
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase">Bundle Name</p>
                <p className="text-sm font-extrabold text-gray-800">{form.name}</p>
              </div>
              <div className="flex justify-between items-center text-xs">
                <div>
                  <p className="text-[10px] font-bold text-gray-400 uppercase">Contains</p>
                  <p className="font-extrabold text-gray-800">{form.kras.length} KRAs</p>
                </div>
                <div className="text-right">
                  <p className="text-[10px] font-bold text-gray-400 uppercase">Total Weight</p>
                  <p className="font-extrabold text-primary">{totalCalculatedWeight}%</p>
                </div>
              </div>
              <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
                <div className="bg-green-700 h-full rounded-full" style={{ width: `${Math.min(100, totalCalculatedWeight)}%` }} />
              </div>
            </div>

            <div className="flex flex-col gap-3 pt-2">
              <button onClick={() => { setShowSuccessScreen(false); onSave(); }} className="w-full bg-primary hover:bg-secondary text-white py-3 rounded-lg font-bold text-xs uppercase hover:shadow-lg transition-all">
                Go to KRA Library
              </button>
              <button onClick={() => { setShowSuccessScreen(false); onClose(); }} className="text-xs text-gray-400 hover:text-red-500 font-bold uppercase transition-colors">
                Back to Dashboard
              </button>
            </div>
          </div>
        </div>
      )}

      {/* WEIGHT ASSIGNMENT MODAL */}
      {showWeightModal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl max-w-lg w-full shadow-xl flex flex-col max-h-[85vh] overflow-hidden animate-scale-in">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h3 className="font-bold text-gray-900 text-lg md:text-xl">Bundle Weight Assignment</h3>
              <button onClick={() => setShowWeightModal(false)} className="text-gray-400 font-bold hover:text-primary transition-transform duration-300 hover:rotate-180"><X/></button>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-6">
              <div className="bg-gray-50 border p-4 rounded-lg">
                <span className="text-[10px] bg-red-100 text-primary font-bold px-2 py-0.5 rounded uppercase">Bundle Identity</span>
                <h4 className="font-bold text-gray-800 text-sm mt-2">{form.name}</h4>
                <p className="text-xs text-gray-400 mt-1 leading-relaxed">{form.description || "No description provided."}</p>
              </div>

              <div className="space-y-4">
                <div className="flex justify-between items-center border-b pb-2 text-[10px] font-bold text-gray-400 uppercase">
                  <span>KRA Name</span>
                  <button
                    type="button"
                    onClick={handleAutoSplitWeights}
                    className="text-[10px] text-primary hover:text-secondary font-bold uppercase underline transition-colors focus:outline-none"
                  >
                    Distribute Equally
                  </button>
                </div>
                
                {form.kras.map((k, idx) => (
                  <div key={idx} className="flex justify-between items-center gap-4">
                    <div className="min-w-0 flex-1">
                      <p className="text-xs font-bold text-gray-800 truncate">{k.name || "Custom KRA"}</p>
                      <p className="text-[10px] text-gray-400 truncate mt-0.5">{k.description}</p>
                    </div>
                    <div className="flex items-center gap-1.5 shrink-0">
                      <input 
                        type="number" 
                        value={k.weightage || ""}
                        onChange={(e) => handleWeightChangeInModal(idx, e.target.value)}
                        className="w-16 border rounded-lg px-2.5 py-1.5 text-center text-xs font-bold outline-none focus:ring-1 focus:ring-red-400"
                        min={0}
                        max={100}
                      />
                      <span className="text-xs text-gray-400 font-bold">%</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="p-6 border-t bg-gray-50 space-y-4">
              <div className="flex justify-between items-center text-xs font-bold">
                <span className="text-gray-700">Current Total: {totalCalculatedWeight}%</span>
                <span className="text-primary tracking-wide text-[10px] uppercase">Total weight must not exceed 100%</span>
              </div>
              <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
                <div className={`h-full rounded-full transition-all duration-300 ${totalCalculatedWeight <= 100 ? "bg-green-500" : "bg-primary"}`} style={{ width: `${Math.min(100, totalCalculatedWeight)}%` }} />
              </div>

              <div className="flex gap-3 pt-2">
                <button onClick={() => setShowWeightModal(false)} className="flex-1 bg-white border py-2.5 rounded-lg text-xs font-bold text-gray-600 hover:bg-gray-100 uppercase">
                  Cancel
                </button>
                <button onClick={handleCreateBundleFinal} disabled={saving} className="flex-1 bg-primary text-white py-2.5 rounded-lg text-xs font-bold uppercase hover:shadow-lg hover:bg-secondary transition-all">
                  {saving ? "Saving..." : (bundle ? "Update Bundle" : "Create Bundle")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Interactive Breadcrumbs Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <nav className="text-xs md:text-sm text-primary font-medium flex items-center gap-1.5 flex-wrap" aria-label="Breadcrumb">
          <button 
            type="button"
            onClick={onClose} 
            className="hover:text-secondary transition-colors focus:outline-none"
          >
            KRA Library
          </button>
          <span className="text-gray-300">&gt;</span>
          
          <button 
            type="button"
            onClick={onBackToWizard || onClose} 
            className="hover:text-secondary transition-colors focus:outline-none"
          >
            Bundle KRA
          </button>
          <span className="text-gray-300">&gt;</span>
          
          <span className="text-secondary font-bold">
            {bundle ? "Edit Bundle" : "Create KRA Bundle"}
          </span>
        </nav>

        <div className="text-lg md:text-2xl font-bold text-gray-900 tracking-tight">
          Bundle KRA
        </div>
      </div>

      {/* BUNDLE DETAILS CARD PANEL */}
      <div className="bg-white rounded-xl p-6 space-y-6">
        <div className="border-b border-gray-100 pb-3 flex items-center gap-2">
          <span className="p-1.5 bg-red-100 rounded-md text-primary"><Library size={20} /></span>
          <h3 className="font-bold text-gray-800 text-sm uppercase tracking-wider">Bundle Information</h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Bundle Name <span className="text-primary">*</span></label>
            <input 
              type="text" 
              value={form.name}
              onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))}
              placeholder="e.g. Executive Leadership Q3"
              className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Financial Year</label>
            <input 
              type="number" 
              value={form.year}
              onChange={(e) => setForm(p => ({ ...p, year: Number(e.target.value) || new Date().getFullYear() }))}
              className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-red-200"
            />
          </div>
          
          {/* Active / Draft Toggle switch */}
          <div className="flex flex-col justify-end">
            <span className="block text-xs font-bold text-gray-700 uppercase mb-1">Status</span>
            <div className="flex items-center gap-3 bg-gray-50/50 p-2 border border-gray-200 rounded-lg max-w-[160px] h-[42px]">
              <button 
                type="button"
                onClick={() => setForm(p => ({ ...p, status: p.status === "ACTIVE" ? "DRAFT" : "ACTIVE" }))}
                className={`relative inline-flex h-6 w-11 rounded-full transition-colors ${form.status === "ACTIVE" ? "bg-primary" : "bg-gray-300"}`}
              >
                <span className={`inline-block h-4 w-4 mt-1 ml-1 rounded-full bg-white transition-transform ${form.status === "ACTIVE" ? "translate-x-5" : "translate-x-0"}`} />
              </button>
              <span className="text-xs font-bold text-gray-600 uppercase">
                {form.status === "ACTIVE" ? "Active" : "Draft"}
              </span>
            </div>
          </div>
        </div>

        <div>
          <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Bundle Description</label>
          <textarea 
            value={form.description}
            onChange={(e) => setForm(p => ({ ...p, description: e.target.value }))}
            placeholder="Key performance indicators for the team focused on strategic growth..."
            rows={3}
            className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-red-200 resize-none"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Review Cycle</label>
            <SelectDropdown options={CYCLE_OPTIONS} value={form.reviewCycle} onChange={(v) => setForm(p => ({ ...p, reviewCycle: v }))} placeholder="Select cycle" valueKey="value" labelKey="label" searchable={true} />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Division</label>
            <SelectDropdown options={divisions} value={form.divisionId} onChange={(v) => setForm(p => ({ ...p, divisionId: v }))} placeholder="Select division" valueKey="value" labelKey="label" searchable={true} />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Department</label>
            <SelectDropdown options={departments} value={form.departmentId} onChange={(v) => setForm(p => ({ ...p, departmentId: v }))} placeholder="Select department" valueKey="value" labelKey="label" searchable={true} />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Designation</label>
            <SelectDropdown options={designations} value={form.designationId} onChange={(v) => setForm(p => ({ ...p, designationId: v }))} placeholder="Select designation" valueKey="value" labelKey="label" searchable={true} />
          </div>
        </div>
      </div>

      {/* KRA LIST BUILDER CONTAINER */}
      <div className="space-y-4">
        <div className="flex justify-between items-center border-b pb-1">
          <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider">KRA List</h4>
          <button onClick={handleAddListItem} className="text-xs bg-primary text-white hover:bg-secondary px-3 py-2 font-bold rounded-lg flex items-center gap-1">
           <Plus strokeWidth={4} size={16}/> Add Another KRA
          </button>
        </div>

        <div className="space-y-4">
          {form.kras.map((k, idx) => (
            <div key={idx} className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm relative space-y-4">
              <div className="flex justify-between items-center">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 font-bold text-[10px]">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <button onClick={() => handleRemoveListItem(idx)} className="text-gray-400 hover:text-red-500 p-1.5 rounded-lg">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>

              <div className="flex items-center gap-4 bg-gray-50 p-2.5 rounded-lg border border-gray-100 max-w-[320px]">
                <button 
                  type="button"
                  onClick={() => handleItemChange(idx, "isNew", false)}
                  className={`flex-1 py-1.5 rounded-lg text-[10px] font-bold uppercase transition-all ${
                    !k.isNew ? "bg-primary text-white shadow-sm" : "text-gray-500 hover:text-white hover:bg-secondary"
                  }`}
                >
                  Select Existing
                </button>
                <button 
                  type="button"
                  onClick={() => handleItemChange(idx, "isNew", true)}
                  className={`flex-1 py-1.5 rounded-lg text-[10px] font-bold uppercase transition-all ${
                    k.isNew ? "bg-primary text-white shadow-sm" : "text-gray-500 hover:text-white hover:bg-secondary"
                  }`}
                >
                  Create Custom New
                </button>
              </div>

              {!k.isNew ? (
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Select KRA Master <span className="text-primary">*</span></label>
                  <SelectDropdown 
                    options={getKrasOptionsForIndex(idx)} 
                    value={k.kraId}
                    onChange={(v) => handleItemChange(idx, "kraId", v)}
                    placeholder="Search and select existing template..."
                    searchable={true}
                    valueKey="value"
                    labelKey="label"
                  />
                </div>
              ) : (
                <div className="space-y-3">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-bold text-gray-700 uppercase mb-1">KRA Name <span className="text-primary">*</span></label>
                      <input 
                        type="text" 
                        value={k.name}
                        onChange={(e) => handleItemChange(idx, "name", e.target.value)}
                        placeholder="e.g. Sales Target Achievement"
                        className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Category <span className="text-primary">*</span></label>
                      <input 
                        type="text" 
                        value={k.category}
                        onChange={(e) => handleItemChange(idx, "category", e.target.value)}
                        placeholder="e.g. Technical, Behavioral"
                        className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Description <span className="text-primary">*</span></label>
                    <textarea 
                      value={k.description}
                      onChange={(e) => handleItemChange(idx, "description", e.target.value)}
                      placeholder="Describe primary objective and outcome..."
                      rows={2}
                      className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200 resize-none"
                    />
                  </div>
                </div>
              )}

              {/* Individual Cycle, Goal Direction and Targets (including metricType) */}
              {/* ✅ Upgraded to sm:grid-cols-5 layout to accommodate Metric Direction seamlessly */}
              <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 border-t border-gray-100 pt-4 bg-gray-50/20 p-3 rounded-lg">
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Review Cycle <span className="text-primary">*</span></label>
                  <SelectDropdown 
                    options={CYCLE_OPTIONS} 
                    value={k.reviewCycle} 
                    onChange={(v) => handleItemChange(idx, "reviewCycle", v)} 
                    placeholder="Select cycle" 
                    valueKey="value" 
                    labelKey="label" 
                    searchable={true}
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-primary uppercase mb-1">Target Value <span className="text-red-500">*</span></label>
                  <input 
                    type="text" 
                    value={k.targetValue}
                    onChange={(e) => handleItemChange(idx, "targetValue", e.target.value)}
                    placeholder="Primary target (e.g. 3 Modules)"
                    className="w-full border border-red-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200 font-bold"
                  />
                </div>
                {/* ✅ Added Goal/Metric Direction Dropdown */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Goal Direction</label>
                  <SelectDropdown 
                    options={METRIC_TYPE_OPTIONS} 
                    value={k.metricType || "HIGHER_IS_BETTER"} 
                    onChange={(v) => handleItemChange(idx, "metricType", v)} 
                    placeholder="Goal Direction" 
                    valueKey="value" 
                    labelKey="label" 
                    searchable={false}
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Monthly Target (Legacy)</label>
                  <input 
                    type="text" 
                    value={k.monthlyTarget}
                    onChange={(e) => handleItemChange(idx, "monthlyTarget", e.target.value)}
                    placeholder="e.g. ₹5 Lakhs"
                    className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase mb-1">Yearly Target (Legacy)</label>
                  <input 
                    type="text" 
                    value={k.yearlyTarget}
                    onChange={(e) => handleItemChange(idx, "yearlyTarget", e.target.value)}
                    placeholder="e.g. ₹60 Lakhs"
                    className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-red-200"
                  />
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>

      {/* Footer action bar */}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 ">
        <button
          onClick={onClose}
          className="w-full sm:w-auto flex items-center justify-center gap-2 px-5 py-2.5 border border-gray-300 text-gray-600 hover:bg-gray-200 font-bold rounded-lg text-xs uppercase transition-colors"
        >
          <TbCancel className="text-base" />
          <span>Discard</span>
        </button>
        
        <button onClick={handleOpenWeightsModal} className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3 bg-primary hover:bg-secondary text-white font-bold rounded-lg text-xs uppercase hover:shadow-lg transition-all">
          {bundle ? "Assign Weights & Update Bundle" : "Assign Weights & Save Bundle"} <MoveRight strokeWidth={2} size={20}/>
        </button>
      </div>
    </div>
  );
}